import React from 'react';
import Modal from './Modal.jsx';

/**
 * Modal for creating a new category
 * @param {boolean} show - Whether the modal is visible
 * @param {Function} onClose - Function to close the modal
 * @param {string} categoryName - Current category name input value
 * @param {Function} onCategoryNameChange - Handler for category name input change
 * @param {Function} onCreateCategory - Handler for creating the category
 * @param {string} errorMessage - Error message to display (if any)
 */
const CategoryModal = ({
  show,
  onClose,
  categoryName,
  onCategoryNameChange,
  onCreateCategory,
  errorMessage,
}) => {
  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      onCreateCategory();
    }
  };

  return (
    <Modal show={show} onClose={onClose} title="Create New Category">
      <input
        type="text"
        placeholder="Enter category name..."
        value={categoryName}
        onChange={onCategoryNameChange}
        onKeyDown={handleKeyDown}
        className="w-full p-3 mb-4 bg-gray-700 border border-gray-600 text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-[#e50914]"
      />
      {errorMessage && (
        <p className="text-red-500 text-sm mb-3">{errorMessage}</p>
      )}
      <button
        onClick={onCreateCategory}
        className="w-full bg-[#e50914] hover:bg-[#b0060f] text-white font-bold py-3 px-6 transition duration-300 ease-in-out"
      >
        Create Category
      </button>
    </Modal>
  );
};

export default CategoryModal;
